import { apiFetch } from "@/lib/api";

export type ClampQcReceiveDisposition = "passed" | "failed" | "all" | "close_short";

export type ClampQcInventoryStatus = {
  buildOrderId: number;
  slug: string;
  sku: string | null;
  plannedQuantity: number;
  hubStatus: string | null;
  executionMode: string | null;
  inspectedCount: number;
  passedCount: number;
  failedCount: number;
  hubReceivedQuantity: number;
  receivablePassedQuantity: number;
  receivableFailedQuantity: number;
  receivedPassedQuantity: number;
  receivedFailedQuantity: number;
  notInspectedQuantity: number;
  laborBlockMessage: string | null;
};

export type ClampQcFinishResponse = {
  ok: true;
  buildOrderId: number;
  slug: string;
  workOrderLabel: string;
  sku: string;
  receivedQuantity: number;
  receivedPassedQuantity: number;
  receivedFailedQuantity: number;
  returnedQuantity: number;
  stockSku: string;
  damagedSku: string | null;
  passedCount: number;
  inspectedCount: number;
  failedCount: number;
  closed: boolean;
  disposition: ClampQcReceiveDisposition;
};

export function fetchClampQcInventoryStatus(slug: string): Promise<ClampQcInventoryStatus> {
  return apiFetch<ClampQcInventoryStatus>(`/api/clamp-qc/work-orders/${encodeURIComponent(slug)}/inventory-status`);
}

export function finishClampQcWorkOrder(
  slug: string,
  disposition: ClampQcReceiveDisposition,
  close = false,
): Promise<ClampQcFinishResponse> {
  return apiFetch<ClampQcFinishResponse>(`/api/clamp-qc/work-orders/${encodeURIComponent(slug)}/finish`, {
    method: "POST",
    body: { disposition, close },
  });
}

export type ClampQcFailContainerPrint = {
  pile: "repairable" | "unrepairable" | "william";
  label: string;
  quantity: number;
  sku: string;
  printed: boolean;
};

export function printClampQcFailContainers(
  slug: string,
  printer: string,
): Promise<{ ok: true; containers: ClampQcFailContainerPrint[] }> {
  return apiFetch(`/api/clamp-qc/work-orders/${encodeURIComponent(slug)}/fail-containers/print`, {
    method: "POST",
    body: { printer },
  });
}
